<div class="loader-h100">
  <div [hidden]="!isLoading" class="text-xs-center loader-inner">
    <mat-spinner diameter="50"></mat-spinner>
    <p>{{ labels?.Loading ? labels?.Loading : 'Loading' }} {{ message }}...</p>
  </div>
</div>
